import { render, staticRenderFns } from "./WidgetContactoLink.vue?vue&type=template&id=77f8b65d&lang=pug&"
import script from "./WidgetContactoLink.vue?vue&type=script&lang=js&"
export * from "./WidgetContactoLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports